import { Card, Grid } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
import { useContext, useEffect } from 'react';
import { useProtesisIniciadoAutorizadoDona } from '../hooks';
import { ProtesisTramitesContext } from '../context';
import { GraficoDoughnut } from './GraficoDoughnut';
dayjs.locale('es'); // activa el idioma español

export const IniciadoPorCategoriaMensualDona = () => {
  const { mensualList, mensualDate } = useContext(ProtesisTramitesContext);
  const { datosMensualesPendientesPorCategoriaDona, getDatosMensualesPendientesPorCategoriaDona } =
    useProtesisIniciadoAutorizadoDona({
      mensualList,
      mensualDate,
    });

  useEffect(() => {
    if (mensualList?.length > 0 && mensualDate) {
      getDatosMensualesPendientesPorCategoriaDona();
    }
  }, [mensualList, mensualDate]);

  return (
    <Card sx={{ px: 3, py: 3, width: '100%', maxWidth: '800px', height: '300px' }}>
      <GraficoDoughnut
        labels={datosMensualesPendientesPorCategoriaDona?.labels || []}
        datasets={datosMensualesPendientesPorCategoriaDona?.datasets || []}
        options={{
          plugins: {
            title: {
              text: 'Estado de autorizaciones pendientes últimos 30 días',
              display: true,
            },
            legend: { position: 'bottom' },
          },
        }}
      />
    </Card>
  );
};
